export default {
  darkIcon: false,
};
